module.exports = __webpack_public_path__ + "static/media/icon-q.511abe49.png";